import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm,autofill,change } from 'redux-form';

import { getSkillAcquisitionDomainList , getSkillAcquisitionProgramList} from "./actions/skillAquisitionDomainActions";
import { getSkillAcquisitionTargetList } from "../Target/actions/skillAquisitionTargetActions";
import { getCurriculumLibrariesList } from "../../../../../../MastersDataCollection/curriculumLibraries/actions/CurriculumLibrariesActions";
import { getDomainList, getProgramList ,copyPatientSkillAcquisitionData } from "./actions/skillAquisitionDomainActions";
import { renderAutoCompleteSingleSelect, renderTextField } from '../../../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../img/small-loader.gif';

import validate from "./validate";
import { checkFieldExistence , clearFieldErrorArray } from "../../../../../../../modules/AppConfig/actions";
import Divider from "material-ui/Divider";


class CopyCurriculumLibraryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            selectedDomain: 0,
            domainData : [],
            programData : [],
            targetData : [],
            targetID : 0,   
            libraryName : [],
            skillsAcquisitionProgramId :0,
            curriculumDomain : [],
            curriculumProgram : [],
            selectedProgram: 0,
            skillAcquisitionDomainId:0,
            domainId: 0,
            patientId:0,
            programId:0,
            selectedMasterDomain:0,
            selectedMasterProgram:0
        };
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        
    }
     
    componentWillReceiveProps = (nextProps) => {
        if (nextProps.skillAcquisitionDomainList !== null && nextProps.skillAcquisitionDomainList !== undefined && nextProps.skillAcquisitionDomainList !== this.props.skillAcquisitionDomainList) {
            let skillAcquisitionDomainData = (nextProps.skillAcquisitionDomainList && nextProps.skillAcquisitionDomainList.data) || [];
            let obj = {}
            skillAcquisitionDomainData.map(item => {obj[item.domainId] = item.domainName})
            this.props.dispatch(autofill("CopyCurriculumLibraryModalForm","domainName",obj[this.props.domainId]))

            skillAcquisitionDomainData.filter((ele)=>ele.domainName===obj[this.props.domainId]&&this.setState({skillAcquisitionDomainId:ele.id,patientId:ele.patientId}));
        }  

        if (nextProps.skillAcquisitionProgram !== null && nextProps.skillAcquisitionProgram !== undefined && nextProps.skillAcquisitionProgram !== this.props.skillAcquisitionProgram) {
            let data =nextProps.skillAcquisitionProgram.data.map((obj)=> obj = {...obj ,value:obj.programName})
            // let proId = [];
            // let domId = [];
            // data.map(ele=>proId.push(ele.skillsAcquisitionProgramId))
            // data.map(ele=>domId.push(ele.skillsAcquisitionDomainId))
            this.setState({
                programData: data,
            });



        }
        if (nextProps.skillAcquisitionTargetList !== null &&nextProps.skillAcquisitionTargetList !== undefined && nextProps.skillAcquisitionTargetList !== this.props.skillAcquisitionTargetList) {
            let data = nextProps.skillAcquisitionTargetList.data.map((obj)=> obj = {...obj ,value:obj.targetName})
            this.setState({
                targetData : data
            })
        }
        if (nextProps.curriculumLibraryList !== null && nextProps.curriculumLibraryList !== undefined && nextProps.curriculumLibraryList !== this.props.curriculumLibraryList) {
            let data = nextProps.curriculumLibraryList.data.map((obj)=> obj = {...obj ,value:obj.libraryName})
            this.setState({
                libraryName: data,
            });
        }

        if (nextProps.curriculumDomainList !== null && nextProps.curriculumDomainList !== undefined && nextProps.curriculumDomainList !== this.props.curriculumDomainList) {
            let data = nextProps.curriculumDomainList.data.map((obj)=> obj = {...obj ,value:obj.domainName})
            this.setState({
                curriculumDomain: data,
            });
        }
        if (nextProps.curriculumProgramList !== null && nextProps.curriculumProgramList !== undefined && nextProps.curriculumProgramList !== this.props.curriculumProgramList ) {
            let data =nextProps.curriculumProgramList.data.map((obj)=> obj = {...obj ,value:obj.programName})
            this.setState({
                curriculumProgram: data,
            });

            // let masterProgId = this.state.curriculumProgram.filter(ele=>this.state.selectedMasterProgram===ele.domainId)
        }

        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
      
    }

    componentDidMount() {
    this.loadData();
    this.handleLibrary();
    }


    handleOpen = () => {
        this.setState({ open: true });
    };

    handleLibrary(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null, ShowArchivedOnly: this.state.ShowArchivedOnly ? '1' : '0',   },
            pageNumber: page_number || 1,
        };
        this.props.getCurriculumLibrariesList(searchObj, true);
    }
    
    handleClose = (page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        if (this.state.open) {
            this.props.clearFieldErrorArray();
            this.setState({ open: false });
            this.props.closeDialog();
            this.props.getSkillAcquisitionProgramList(searchObj, this.props.patientId, this.props.domainId,false)
        }
    };

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    onSubmitHandler() {
        let paramObj = {
            "SkillsAcquisitionDomainId": this.state.skillAcquisitionDomainId,
            "SkillAcquisitionProgramId":this.state.selectedProgram,
            "SkillAcquisitionTargetId": this.state.targetID,
            "LibraryId": this.state.selectedDomain,
            "DomainId":this.state.selectedMasterDomain,
            "ProgramId": this.state.selectedMasterProgram, 
            "PatientId": this.state.patientId,
        }

        this.props.copyPatientSkillAcquisitionData(paramObj);
        this.setState({ open: false });
        this.props.closeDialog();
    }
    loadData(page_number){
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        this.props.getSkillAcquisitionDomainList(searchObj, this.props.patientId)
        this.props.getSkillAcquisitionProgramList(searchObj, this.props.patientId, this.props.domainId,true)
    }
    
    handleSelectTarget=(input,selected)=>{
        input.onChange(selected.value)
        this.setState({targetID:selected.value});
    }

    handleNewRequestProgram = (input,selected,page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        input.onChange(selected.value);
        this.props.dispatch(change('CopyCurriculumLibraryModalForm', 'targetName', null));
        this.setState({selectedProgram: selected.value, targetData: []},()=>{
            this.props.getSkillAcquisitionTargetList(searchObj, this.props.patientId,this.state.selectedProgram, true)
        })
    }

    handleNewRequestCurriculumLibraries = (input,selected,page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null, ShowArchivedOnly: this.state.ShowArchivedOnly ? '1' : '0', },
            pageNumber: page_number || 1,
        };
        input.onChange(selected.value);
        this.props.dispatch(change('CopyCurriculumLibraryModalForm', 'MasterDomainId', null));
        this.props.dispatch(change('CopyCurriculumLibraryModalForm', 'masterProgramId', null));
        this.setState({selectedDomain : selected.value, selectedMasterDomain: 0, selectedMasterProgram: 0, curriculumDomain: [], 
            curriculumProgram: [] }, () => {
            this.props.getDomainList(searchObj, this.state.selectedDomain , true);
        })
    }

    handleNewRequestMasterDomain=(input,selected,page_number)=>{
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null, ShowArchivedOnly: this.state.ShowArchivedOnly ? '1' : '0', },
            pageNumber: page_number || 1,
        };
        input.onChange(selected.value);
        this.props.dispatch(change('CopyCurriculumLibraryModalForm', 'masterProgramId', null));
        this.setState({selectedMasterDomain : selected.value, selectedMasterProgram: 0, curriculumProgram: [] }, () => {
            this.props.getProgramList(searchObj, this.state.selectedMasterDomain, true);
        })
    }
    handleNewRequestMasterProgram=(input,selected)=>{
        input.onChange(selected.value);
        this.setState({selectedMasterProgram : selected.value})
    }

    render() {
        const { handleSubmit } = this.props;
        let submitButton = this.props.loading ?
            <SubmitButtonModalDisabled label="Loading" /> :
            <SubmitButtonModal label="Copy" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
            submitButton,
        ];
        return <Dialog className="custom_modal" title="Copy to Curriculum Library" modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
           {this.renderLoading()}
            <div className="row">
                <div className="col-sm-12">
                    <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
                        <div className="row">
                            <div className="mt-30" style={{fontWeight: "bold"}}>Select Domain/Program/Target to copy :</div>
                            <div className="col-sm-12 mt-30">
                                <Field 
                                    autoFocus={true}
                                    name="domainName"
                                    label="Domain"
                                    type="text"
                                    disabled = {true}
                                    component={renderTextField}
                                />
                            </div>
                            <div className='col-sm-12 mt-30'>
                                <Field
                                name="programId"
                                label="Program"
                                options={this.state.programData}
                                handleNewRequest={this.handleNewRequestProgram}
                                component={renderAutoCompleteSingleSelect}
                                />
                            </div>
                            <div className='col-sm-12 mt-30'>
                                <Field
                                name="targetName"
                                label="Target"
                                options={this.state.targetData}
                                handleNewRequest={this.handleSelectTarget}
                                component={renderAutoCompleteSingleSelect}
                                />
                            </div>
                        </div>
                        <Divider/>
                        <div className="row">
                            <div className="mt-30" style={{fontWeight: "bold"}}>Copy Domain/Program/Target to Curriculum Library :</div>
                            <div className="col-sm-12 mt-30">
                                <Field autoFocus={true}
                                    name="libraryId"
                                    label="Library"
                                    handleNewRequest={this.handleNewRequestCurriculumLibraries}
                                    options={this.state.libraryName}
                                    component={renderAutoCompleteSingleSelect} />
                                </div>
                            <div className="col-sm-12 mt-30">
                                <Field autoFocus={true}
                                    name="MasterDomainId"
                                    label="Domain"
                                    handleNewRequest={this.handleNewRequestMasterDomain}
                                    options={this.state.curriculumDomain}
                                    disabled={this.state.selectedProgram ? false : true}
                                    component={renderAutoCompleteSingleSelect} />
                            </div>
                            <div className='col-sm-12 mt-30'>
                                <Field
                                name="masterProgramId"
                                label="Program"
                                options={this.state.curriculumProgram}
                                disabled ={this.state.targetID? false: true}
                                handleNewRequest={this.handleNewRequestMasterProgram}
                                component={renderAutoCompleteSingleSelect}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Dialog>;
    }
}

CopyCurriculumLibraryModal = reduxForm({
    form: 'CopyCurriculumLibraryModalForm',
    validate,
    enableReinitialize: true,
})(CopyCurriculumLibraryModal);


function mapStateToProps(state) {
     return {
        loading: state.domain.loading || state.skillAcquisitionDomain.loading,
        skillAcquisitionDomainList: state.skillAcquisitionDomain.skillAcquisitionDomainList,
        skillAcquisitionProgram: state.skillAcquisitionDomain.skillAcquisitionProgramOne,
        skillAcquisitionTargetList: state.skillAcquisitionTarget.skillAcquisitionTargetList,        
        curriculumLibraryList : state.curriculumLibraries.curriculumLibrariesList,
        curriculumDomainList : state.skillAcquisitionDomain.domainList,
        curriculumProgramList : state.skillAcquisitionDomain.programList
    }
}

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, getSkillAcquisitionDomainList ,getSkillAcquisitionProgramList, getSkillAcquisitionTargetList, getCurriculumLibrariesList, getDomainList, getProgramList ,copyPatientSkillAcquisitionData})(CopyCurriculumLibraryModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Domain/CopyCurriculumLibraryModal.js